import React from 'react'
import { Stack } from '@mui/material'
import DateRangeFilter from './FilterComponents/DateRangeFilter'
import SentimentalFilter from './FilterComponents/SentimentalFilter'
import { CampaignFilter, DepartmentFilter } from './FilterComponents/DepartmentFilter'

const DashBoardFilters = ({setFilters , filters , exitInterviewCampaigns , departments }) => {
  return (
    <Stack sx={{display : 'flex', flexDirection: 'row' , flexWrap : 'wrap' , gap : 2}} >
    <DateRangeFilter setFilters={setFilters} defaultValue={filters?.dateRange} />
    <CampaignFilter setFilters={setFilters} value={filters?.campaignIds || []} options={exitInterviewCampaigns} />
    <DepartmentFilter setFilters={setFilters} value={filters?.departments || []} options={departments} />
    <SentimentalFilter setFilters={setFilters} defaultValue={filters?.sentimentBucket} />
    </Stack>
  )
}

export default DashBoardFilters